import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, Box, Typography } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';

const SnackbarDevelopment = ({ title, onlyNotify = false }) => {
  const [open, setOpen] = useState(false);

  // Se activa automáticamente al montar el componente
  useEffect(() => {
    setOpen(true);
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  const renderSnackbar = () => (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={open}
      autoHideDuration={4000}
      onClose={handleClose}
    >
      <Alert 
        onClose={handleClose} 
        severity="info" 
        variant="filled" 
        sx={{ width: '100%', fontWeight: '500' }}
      >
        {`The ${title} module is under construction.`}
      </Alert>
    </Snackbar>
  );

  // VALIDACIÓN: Si solo queremos la notificación
  if (onlyNotify) {
    return renderSnackbar();
  }

  // Si queremos la vista completa de "En Construcción"
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '60vh',
        textAlign: 'center',
        p: 3
      }}
    >
      <ConstructionIcon sx={{ fontSize: 80, mb: 2, color: 'action.active', opacity: 0.3 }} />
      <Typography variant="h4" color="text.primary" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        We are working hard to bring you this feature soon.
      </Typography>
      
      {renderSnackbar()}
    </Box>
  );
};

export default SnackbarDevelopment;